import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const EmailCapture = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/subscribe`, { email });
      setDone(true);
      toast.success(res.data.message || "You're in.");
    } catch (err) {
      const msg = err?.response?.data?.detail?.[0]?.msg || "Enter a valid email.";
      toast.error(typeof msg === "string" ? msg : "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="free-tips" className="relative py-24 lg:py-32 bg-[#0a0a0a] border-y border-white/10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-accent">// Free, no card needed</span>
          <h2 className="mt-5 font-display font-black uppercase tracking-tighter text-4xl sm:text-6xl leading-[0.9]">
            5 settings to change<br />right now
          </h2>
          <p className="mt-6 font-body text-white/50 leading-relaxed max-w-xl">
            Drop your email and get 5 genuinely useful privacy settings you can change in 10 minutes, sent straight to your inbox. A real taste of the full pack. No spam, unsubscribe anytime.
          </p>

          {done ? (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              data-testid="subscribe-success"
              className="mt-10 font-mono text-sm uppercase tracking-[0.15em] text-accent border border-accent/40 inline-block px-6 py-4"
            >
              ✦ Transmission secured. Welcome to the resistance.
            </motion.div>
          ) : (
            <form onSubmit={submit} className="mt-10 flex flex-col sm:flex-row gap-px max-w-xl border border-white/15 bg-black/40">
              <input
                data-testid="subscribe-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@encrypted-email.com"
                required
                className="flex-1 bg-transparent px-6 py-5 font-mono text-sm text-white placeholder:text-white/30 focus:outline-none focus:bg-white/[0.03]"
              />
              <button
                data-testid="subscribe-submit-button"
                type="submit"
                disabled={loading}
                className="group flex items-center justify-center gap-2 bg-accent text-white font-mono uppercase tracking-[0.15em] text-xs px-8 py-5 hover:bg-white hover:text-black transition-colors duration-300 disabled:opacity-70"
              >
                {loading ? <Loader2 size={16} className="animate-spin" /> : <>Subscribe <ArrowRight size={15} className="group-hover:translate-x-1 transition-transform" /></>}
              </button>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};
